export const environment = {
  production: false,
  urlApi: 'https://97179kzo30.execute-api.us-east-1.amazonaws.com/dev/api/v1'
  // urlApi: 'http://localhost:8001/api/v1'
};
